module.exports = __webpack_public_path__ + "media/images/emoticons/scissors-fb2dafd030b76e52806c15cb5aa11799.gif";